import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { getofferProducts } from "../../store/totaloffer/totaloffAction";
import { Link, useParams } from "react-router-dom";
import Card from "../../component/Card";
import Loader from "../../component/Loader";
import React from "react";
import ReactPaginate from 'react-paginate';
import grid from "../../assets/logo/all.png"
import mini from "../../assets/logo/mini.png"
import catBaner from "../../assets/gal6.jpg";
import img1 from "../../assets/222.jpeg";
import img2 from "../../assets/3-camera_lockup_white.png";
import img3 from "../../assets/7723324_orig.jpg";
import img4 from "../../assets/Lorex-Camera.png";
import img5 from "../../assets/cm104-1.jpg";
import img6 from "../../assets/essential-xl-v2-right.png";
import img7 from "../../assets/lap1.png";
import img8 from "../../assets/lap2.jpg";
import img9 from "../../assets/lap3.jpg";
import img10 from "../../assets/lap4.jpg";
import img11 from "../../assets/lap9.jpg";
import img12 from "../../assets/lap6.jpg";
import Bread from "../../component/Bread";
const Shop = () => {
  // const { t } = useTranslation();
  // const dispatch = useDispatch();
  // const lan = useSelector((state) => state.LanSlicer.language);
  // const { offerProducts, loading } = useSelector((state) => state.Offers);

  // const { id } = useParams();
  // const [upperVal, setUpperVal] = useState(2000);
  // const [filteredProducts, setFilteredProducts] = useState([]);
  // const [selectedColor, setSelectedColor] = useState(null);
  // const [selectedSize, setSelectedSize] = useState(null);

  // const [currentPage, setCurrentPage] = useState(0);
  // const [productsPerPage] = useState(9);

  // const filterProductsByColor = (color) => {
  //   const filtered = offerProducts?.filter((product) => {
  //     const colorAttributes = product?.attributes?.filter((attr) => {
  //       const nameVariations = ["Color", "colour", "color_name", "اللون"];
  //       return nameVariations?.some(
  //         (name) => attr?.name?.toLowerCase() === name?.toLowerCase()
  //       );
  //     });


  //     const matchesColor = colorAttributes?.some(attr => attr?.value?.toLowerCase() === color?.toLowerCase());

  //     return matchesColor;
  //   });

  //   setFilteredProducts(filtered);
  //   setCurrentPage(0);
  // };
  // useEffect(() => {
  //   const colors = offerProducts?.flatMap((product) => {
  //     if (product && product?.attributes) {
  //       return product?.attributes
  //         .filter(attr => ["Color", "color", "colour", "color_name", "اللون"].includes(attr?.name?.toLowerCase()))
  //         .map(attr => attr?.value);
  //     }
  //     return [];
  //   });

  //   const uniqueColors = [...new Set(colors?.filter((color) => color !== null))];
  //   setUniqueColors(uniqueColors);
  // }, [offerProducts]);

  // useEffect(() => {
  //   const Sizes = offerProducts?.flatMap((product) => {
  //     if (product && product.attributes) {
  //       return product.attributes
  //         .filter(attr => ["measuring", "المقاس"].includes(attr?.name?.toLowerCase()))
  //         .map(attr => attr?.value);
  //     }
  //     return [];
  //   });

  //   const uniqueSizes = [...new Set(Sizes?.filter((size) => size !== null))];
  //   setUniqueSizes(uniqueSizes);
  // }, [offerProducts]);

  // const indexOfLastProduct = (currentPage + 1) * productsPerPage;
  // const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  // const currentProducts = filteredProducts?.slice(indexOfFirstProduct, indexOfLastProduct);

  // const handlePageClick = ({ selected }) => {
  //   setCurrentPage(selected);
  // };
  // const filterProductsBySize = (size) => {
  //   const filtered = offerProducts?.filter((product) => {
  //     const sizeAttributes = product?.attributes?.filter((attr) => {
  //       const sizeVariations = ["Size", "المقاس", "measuring"];
  //       return sizeVariations.some(
  //         (name) => attr?.name?.toLowerCase() === name?.toLowerCase()
  //       );
  //     });
  //     const matchesSize = sizeAttributes?.some(attr => attr?.value?.toLowerCase() === size?.toLowerCase());
  //     return matchesSize;
  //   });

  //   setFilteredProducts(filtered);
  //   setCurrentPage(0);
  // };

  // const [uniqueColors, setUniqueColors] = useState([]);
  // const [uniqueSizes, setUniqueSizes] = useState([]);


  // const handleColorSelection = (color) => {
  //   setSelectedColor(color);
  //   filterProductsByColor(color);
  //   closeNav();
  // };

  // const handleSizeSelection = (size) => {
  //   setSelectedSize(size);
  //   filterProductsBySize(size);
  //   closeNav();
  // };

  // useEffect(() => {
  //   if (!offerProducts?.length) {
  //     dispatch(getofferProducts({ lan, id }));
  //   }
  //   clearSizeFilter();
  //   clearColorFilter();
  // }, [dispatch, lan, id, offerProducts]);

  // const handleUpperChange = (e) => {
  //   let newValue = parseInt(e.target.value);
  //   setUpperVal(newValue);
  //   filterByPrice(newValue);
  // };

  // const filterByPrice = (upperValue) => {
  //   const filtered = offerProducts?.filter(
  //     (product) => product?.price <= upperValue
  //   );
  //   setFilteredProducts(filtered);
  //   setCurrentPage(0);
  // };

  // const clearSizeFilter = () => {
  //   setSelectedSize(null);
  //   setFilteredProducts(offerProducts);
  //   setCurrentPage(0);
  // };

  // const clearColorFilter = () => {
  //   setSelectedColor(null);
  //   setFilteredProducts(offerProducts);
  //   setCurrentPage(0);
  // };

  // useEffect(() => {
  //   dispatch(getofferProducts({ lan, id }));
  //   clearSizeFilter();
  //   clearColorFilter();
  // }, [lan, dispatch, id]);

  // const [isExpanded, setIsExpanded] = useState(false);
  // const handleone = () => {
  //   setIsExpanded(false);
  // };
  // const handletwo = () => {
  //   setIsExpanded(true);
  // };
  // const [navWidth, setNavWidth] = useState(0);
  // const openNav = () => {
  //   setNavWidth(330);
  // };
  // const closeNav = () => {
  //   setNavWidth(0);
  // };
  return (
   
     
    <Fragment>
    <Bread title={"Home"} sub={"Shop"} /> 

    <section className="section-wrap pt-70 pb-40 catalogue">
      <div className="container relative">
        <div className="row">
          <div className="col-md-9 catalogue-col right mb-50">       
            <div className="banner-wrap relative">
              <img src={catBaner} alt=""/>
              <div className="hero-holder text-center right-align">
                <div className="hero-lines mb-0">
                  <h1 className="hero-heading white">Women Collection</h1>
                  <h4 className="hero-subheading white uppercase">HOT AND FRESH TRENDS OF THIS YEAR</h4>
                </div>
              </div>
            </div>

            <div className="shop-filter">
              <p className="result-count">Showing: 1-12 of 80 results</p>
              <form className="ecommerce-ordering">
                <select>
                  <option value="default-sorting">Default Sorting</option>
                  <option value="price-low-to-high">Price: high to low</option>
                  <option value="price-high-to-low">Price: low to high</option>
                  <option value="by-popularity">By Popularity</option>
                  <option value="date">By Newness</option>
                  <option value="rating">By Rating</option>
                </select>
              </form>
            </div>

            <div className="shop-catalogue grid-view left">
              <div className="row row-10 items-grid">
                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img1} alt=""/>
                      </Link>
                      <div className="product-label">
                        <span className="sale">sale</span>
                      </div>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>
                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Night Party Dress</a>
                      </h3>
                      <span className="price">
                        <del>
                          <span>$388.00</span>
                        </del>
                        <ins>
                          <span className="ammount">$159.99</span>
                        </ins>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img2} alt=""/>
                        
                      </Link>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>
                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Elegant White Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$219.00</span>
                        </ins>
                      </span>
                    </div>                          
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img3} alt=""/>
                        
                      </Link>
                      <span className="sold-out valign">out of stock</span>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>
                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Long Black Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$99.00</span>
                        </ins>
                      </span>
                    </div>                        
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img4} alt=""/>
                        
                      </Link>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>
                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Sexy Pink Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$120.00</span>
                        </ins>
                      </span>
                    </div>                        
                  </div>
                </div>


                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img5} alt=""/>
                        
                      </Link>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Minty Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$399.00</span>
                        </ins>
                      </span>
                    </div>                          
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img6} alt=""/>
                        
                      </Link>
                      <div className="product-label">
                        <span className="sale">sale</span>
                      </div>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Sexy White Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$119.00</span>
                        </ins>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img7} alt=""/>
                        
                      </Link>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Elegant Pink Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$1379.00</span>
                        </ins>
                      </span>
                    </div>              
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img8} alt=""/>
                        
                      </Link>
                      <div className="product-label">
                        <span className="sale">sale</span>
                      </div>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Gray California Dress</a>
                      </h3>
                      <span className="price">
                        <del>
                          <span>$350.00</span>
                        </del>
                        <ins>
                          <span className="ammount">$150.00</span>
                        </ins>
                      </span>
                    </div>                  

                  </div>
                </div>


                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img9} alt=""/>
                        
                      </Link>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Minty Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$399.00</span>
                        </ins>
                      </span>
                    </div>                          
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img10} alt=""/>
                        
                      </Link>
                      <div className="product-label">
                        <span className="sale">sale</span>
                      </div>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Sexy White Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$119.00</span>
                        </ins>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img11} alt=""/>
                        
                      </Link>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Elegant Pink Dress</a>
                      </h3>
                      <span className="price">
                        <ins>
                          <span className="ammount">$1379.00</span>
                        </ins>
                      </span>
                    </div>              
                  </div>
                </div>

                <div className="col-md-4 col-xs-6">
                  <div className="product-item">
                    <div className="product-img">
                    <Link to={"/Singleproduct"}>
                        <img src={img12} alt=""/>
                        
                      </Link>
                      <div className="product-label">
                        <span className="sale">sale</span>
                      </div>
                      <div className="product-actions">
                        <a href="#" className="product-add-to-compare" data-toggle="tooltip" data-placement="bottom" title="Add to compare">
                          <i className="fa fa-exchange"></i>
                        </a>
                        <a href="#" className="product-add-to-wishlist" data-toggle="tooltip" data-placement="bottom" title="Add to wishlist">
                          <i className="fa fa-heart"></i>
                        </a>                    
                      </div>
                      <a href="#" className="product-quickview">Quick View</a>
                    </div>

                    <div className="product-details">
                      <h3>
                        <a className="product-title" href="#">Gray California Dress</a>
                      </h3>
                      <span className="price">
                        <del>
                          <span>$350.00</span>
                        </del>
                        <ins>
                          <span className="ammount">$150.00</span>
                        </ins>
                      </span>
                    </div>                  

                  </div>
                </div>
              </div> 
            </div> 
            <div className="clear"></div>       
            <div className="pagination-wrap">
              <p className="result-count">Showing: 1-12 of 80 results</p>              
              <nav className="pagination right clear">
                <a href="#"><i className="fa fa-angle-left"></i></a><span className="page-numbers current">
                1</span><a href="#">
                2</a><a href="#">
                3</a><a href="#">
                4</a><a href="#">
                <i className="fa fa-angle-right"></i></a>
              </nav>
            </div>
          </div> 
          <aside className="col-md-3 sidebar left-sidebar">          
            <div className="widget categories">
              <h3 className="widget-title uppercase">Categories</h3>
              <ul className="list-no-dividers">
                <li>
                  <a href="#">Women</a>
                </li>
                <li className="active-cat">
                  <a href="#">Men</a>
                </li>
                <li>
                  <a href="#">Accessories</a>
                </li>
                <li>
                  <a href="#">Bags</a>
                </li>
                <li>
                  <a href="#">Watches</a>
                </li>
                <li>
                  <a href="#">Shoes</a>
                </li>
              </ul>
            </div>

        
            <div className="widget categories">
              <h3 className="widget-title uppercase">Select size</h3>
              <ul className="list-no-dividers">
                <li>
                  <a href="#">Large</a>
                </li>
                <li>
                  <a href="#">Medium</a>
                </li>
                <li>
                  <a href="#">Small</a>
                </li>
                <li>
                  <a href="#">X-Large</a>
                </li>
                <li>
                  <a href="#">X-Small</a>
                </li>
              </ul>
            </div>
            <div className="widget categories">
              <h3 className="widget-title uppercase">Select color</h3>
              <ul className="list-no-dividers">
                <li>
                  <a href="#">White</a>
                </li>
                <li>
                  <a href="#">Grey</a>
                </li>
                <li>
                  <a href="#">Black</a>
                </li>
                <li>
                  <a href="#">Pink</a>
                </li>
                <li>
                  <a href="#">Green</a>
                </li>
              </ul>
            </div>
            <div className="widget filter-by-price clearfix">
              <h3 className="widget-title uppercase">Filter by Price</h3>
              <div id="slider-range"></div>
              <p>
                <label for="amount">Price:</label>
                <input type="text" id="amount" readonly style={{border:"0"}}/>
                <a href="#" className="btn btn-sm btn-dark">Filter</a>
              </p>
            </div>
            <div className="widget bestsellers">
              <div className="products-widget">
                <h3 className="widget-title uppercase">Bestsellers</h3>
                <ul className="product-list-widget">
                  <li className="clearfix">
                    <a href="#">
                      <img src={img1} alt=""/>
                      <span className="product-title">Sleeveless dress</span>
                    </a>
                    <span className="price">
                      <ins>
                        <span className="ammount">$120.00</span>
                      </ins>
                    </span>
                  </li>
                  <li className="clearfix">
                    <a href="#">
                      <img src={img2} alt=""/>
                      <span className="product-title">Violet Party Dress</span>
                    </a>
                    <span className="price">
                      <ins>
                        <span className="ammount">$179.00</span>
                      </ins>
                    </span>
                  </li>               
                </ul>
              </div>
            </div>

        
            <div className="widget tags clearfix">
              <h3 className="widget-title uppercase">Tags</h3>
              <a href="#">Multi-purpose</a>
              <a href="#">Creative</a>
              <a href="#">Elegant</a>
              <a href="#">Clean</a>
              <a href="#">Modern</a>
              <a href="#">Responsive</a>
              <a href="#">E-commerce</a>
              <a href="#">WordPress</a>
              <a href="#">Woocommerce</a>
              <a href="#">Store</a>
              <a href="#">Business</a>
            </div>

          </aside> 

        </div>
      </div> 
      </section>
  
</Fragment>
      
  );
};

export default React.memo(Shop);
